import { useEffect } from "react";
import { App } from "@capacitor/app";
import { isNativePlatform } from "@/lib/capacitor";
import { parsePaymentSuccessFromAppUrl } from "@/lib/payment-return-url";
import { useNavigate } from "react-router-dom";

export default function AppUrlHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) {
      return;
    }

    const handleUrl = (rawUrl: string) => {
      const payment = parsePaymentSuccessFromAppUrl(rawUrl);
      if (!payment) {
        return;
      }

      navigate(
        `/payment/success?paymentAttemptId=${encodeURIComponent(payment.paymentAttemptId)}&orderId=${encodeURIComponent(payment.orderId)}`,
        { replace: true },
      );
    };

    void App.getLaunchUrl().then((result) => {
      if (result?.url) {
        handleUrl(result.url);
      }
    });

    const listener = App.addListener("appUrlOpen", (event) => {
      handleUrl(event.url);
    });

    return () => {
      void listener.then((handle) => handle.remove());
    };
  }, [navigate]);

  return null;
}
